module.exports = __webpack_public_path__ + "img/112.cbf21fae.png";